import React, { useContext, useState } from 'react'
import GiphyAppAd from 'shared/components/ads/giphy-app'
import Info from 'shared/components/channel-info/info'
import ChannelPageContext from 'shared/contexts/channel-page'
import Screensaver from 'shared/components/screensaver/screensaver'
import UploadClipsCTAComponent from 'shared/components/upload-clips-cta'
import { VideoPreviewChannelGrid } from 'shared/components/video-preview-grid'
import SharedVideoPaginationCarousel from 'shared/components/video-preview-thumbnail/pagination-carousel'
import { getUrl } from 'shared/util/gif-extract'
import { grid12, grid3, grid9, gridSpacing } from 'shared/util/grid'
import { WhenInView } from 'shared/util/in-view'
import styled from 'styled-components'
import ChannelBanner from './channel-banner'
import PaginationCarousels, { BranchGrid } from './children/pagination-carousels'
import ForHireModal from './for-hire-modal'
import BulkEditLauncher from './gifs/bulk-edit-launcher'
import ChannelGrid from './gifs/grid'
import ChannelHeader from './header'
import Stories from './stories'

const Container = styled.div`
    padding-top: 30px;
    display: flex;
    flex-direction: column;
    width: ${grid12}px;
`

const ContentContainer = styled.div`
    display: flex;
`

const Sidebar = styled.div`
    margin-right: ${gridSpacing}px;
    width: ${grid3}px;
`

const Content = styled.div`
    width: ${grid9}px;
`

const VideoPaginationCarousel = styled(SharedVideoPaginationCarousel)`
    margin-top: 30px;
`

const UploadClipsCTA = styled(UploadClipsCTAComponent)`
    margin-bottom: 30px;
`

const RootChannel = ({ deepRefreshKey }) => {
    const { isSearch, channelType, isOwner, channel, isTagView, searchQuery: query } = useContext(ChannelPageContext)
    const { parent, screensaver_gif, has_children, user, video_channel, children: channelChildren } = channel
    const [noResults, setNoResults] = useState<boolean>(false)
    const [isModalActive, setIsModalActive] = useState<boolean>(false)
    const username = user ? user.username : ''
    const isChild = !!parent
    const screensaverUrl = getUrl(screensaver_gif, 'fixed_height') || ''
    const isBranch = isChild && has_children
    const hasVideo = video_channel && video_channel.feed_count > 0
    const onNoGifsUpdate = (noResults: boolean = false) => {
        setNoResults(noResults)
    }
    const showModal = () => {
        // Set (or unset) locked grid scrolling
        if (isModalActive) {
            document.body.style.overflow = ''
        } else {
            document.body.style.overflow = 'hidden'
        }
        setIsModalActive(!isModalActive)
    }
    return (
        <Container>
            <BulkEditLauncher />
            <ChannelBanner />
            <ContentContainer>
                {isModalActive ? <ForHireModal user={user} deactivateModal={showModal} /> : null}
                <Sidebar>
                    <Info
                        channel={channel}
                        isOwner={isOwner}
                        search={query}
                        isTagView={isTagView}
                        showModal={showModal}
                    >
                        {isOwner && noResults && <GiphyAppAd />}
                    </Info>
                </Sidebar>
                <Content>
                    <ChannelHeader />
                    {!hasVideo && isOwner && <UploadClipsCTA gaCategory="channel" />}
                    {username && !isChild && !isSearch && (
                        <Stories isOwner={isOwner} username={username} title={'Stories'} />
                    )}
                    <div key={deepRefreshKey}>
                        {!isSearch &&
                            !isTagView &&
                            (isBranch ? (
                                <BranchGrid channels={channelChildren} />
                            ) : (
                                <PaginationCarousels channels={channelChildren} />
                            ))}
                        {hasVideo && (
                            <VideoPaginationCarousel
                                title={`Clips`}
                                channel={channel.video_channel!}
                                titleUrl={channel.video_channel!.url}
                                width={grid9}
                                hideAttribution
                            />
                        )}
                        <WhenInView dontUnmount>
                            {channelType === 'video_channel' ? (
                                <VideoPreviewChannelGrid channelId={channel.id} previewWidth={grid3} hideAttribution />
                            ) : (
                                <ChannelGrid isOwner={isOwner} onNoResultsUpdate={onNoGifsUpdate} />
                            )}
                        </WhenInView>
                    </div>
                </Content>
                {screensaverUrl ? <Screensaver images={[screensaverUrl]} /> : null}
            </ContentContainer>
        </Container>
    )
}
export default RootChannel
